// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__38xgR","alert":"SettungsInbox_alert__3IDUQ"};